var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notice-content"},[_c('h2',{staticClass:"h2-title"},[_vm._v(_vm._s(_vm.details.title))]),_c('p',{staticClass:"notice-text"},[_vm._v(_vm._s(_vm.details.content))])])}
var staticRenderFns = []

export { render, staticRenderFns }